<template>
  <div class="footer" >
    <div class="footer--content" ref="refShare">
      <!-- <div class="footer--content__left" v-html="baseInfo"></div> -->
      <div class="footer--content__left" >
        <!-- <img src="@/assets/imgs/bott_l.jpg" alt="" class="footer--content__left_img"> -->
        <div class="footer--content__left_img">
          <img src="@/assets/imgs/bott_.jpg" alt="" class="img">
        </div>
        <div v-html="baseInfo"></div>
      </div>
      <div class="footer--content__center">
        <div class="footer--content__center_nav" v-for="(item,i) in navData" :key="i">
          <h3 @click.stop="toPage(item.top.menu_id)">{{item.top.menu_name}}</h3>
          <ul  v-if="item.bottom">
            <li v-for="(item,i) in item.bottom" :key="i" @click.stop="toDetails(item.menu_id)">
              {{item.menu_name}}
            </li>
          </ul>
        </div>
      </div>
      <div class="footer--content__right">
        <img :src="'http://admin.origination.cn/'+qr_code" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'Footer',
  data(){
    return{
      // 二维码信息
      qr_code:'',
      baseInfo:null,
      // 菜单栏
      navData:[],
    }
  },
  methods:{
    // 监听距离顶部的距离
    handleScroll(){
    this.$store.commit('monitorScroll',this.$refs.refShare.getBoundingClientRect().top)
    },

    // 底部菜单
    getFooter(){
      this.$post('api/index/index/footer').then(res => {
        // console.log(res)
        if(res.code == 1){
          this.navData = res.data.menu
          this.qr_code = res.data.bottoms.qr_code
          if(res.data.bottoms.content!=null){
            this.baseInfo = this.$addName(res.data.bottoms.content)
          }
        }else{
          alert(res.data.msg)
        }
      })
      .catch(err => {
        alert(err)
      })
    },
    // 店家菜单栏跳转
    toPage(menu_id){
      if(menu_id==1){
        this.$router.push({name: "HomePage"})
      }
      else if(menu_id==2){
        this.$router.push('/aboutUs')
      }
      else if(menu_id==3){
        this.$router.push('/serveProducts')
      }
      else if(menu_id==4){
        this.$router.push('/latestNews')
      }
      else if(menu_id==5){
        this.$router.push('/contactUs')
      }
    },
    // 跳转到二级栏目
    toDetails(menu_id){
      this.$router.push({
        path:'/MenuDetails',
        query:{
          id:menu_id
        }
      })
    },
  },
  created(){
    // 添加监听事件
    window.addEventListener('scroll', this.handleScroll, true);
    // 底部菜单栏
    this.getFooter()
  }

}
</script>

<style lang="less" scoped>
  .footer{
    font-size: calc(100vw / 19.2)!important;
    width: 100%;
    padding: 1% 0;
    background: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    .footer--content{
      width: 70%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      /deep/.footer--content__left{
        width: 30%;
        overflow: hidden;
        color: #ffffff;
        font-size: .05em;
        .footer--content__left_img{
          font-size: 2em;
          .img{
            width: 15em;
            height: auto;
            margin-bottom: .2em;
          }
          
        }
      }
      .footer--content__center{
        width: 37%;
        display: flex;
        justify-content: space-between;
        .footer--content__center_nav{
          display: flex;
          flex-direction: column;
          color: #777777;
          text-align: center;
          h3{
            font-size: .18em;
            line-height: 2.45em;
            font-weight: normal;
            cursor: pointer;
          }
          ul{
            li{
            font-size: .12em;
            line-height: 2.26em;
            cursor: pointer;
            }
          }
          
        }
      }
      .footer--content__right{
        width: 13%;
        display: flex;
        justify-content: center;
        // img{
        //   // width: 100%;
        //   height: auto;
        // }
      }
    }
  }
  // 手机端
   @media screen and (max-width:750px) { /*一栏布局*/
   .footer{
     padding: 7% 0 !important;
     .footer--content{
      flex-wrap: wrap;
      flex-direction: column;
      >div{
        margin-bottom: 20%;
        &:last-child{
          margin: 0;
        }
      }
      .footer--content__center{
        order: -1; //改变元素排列顺序默认为0，小于0 在前，大于0 在后
        width: 100% !important;
        .footer--content__center_nav{
          h3{
            font-size: .2rem !important;
            line-height: .6rem !important;
          }
          li{
            font-size: .12rem !important;
            line-height: .4rem !important;
          }
        }
      }
      .footer--content__left{
        width: 100% !important;
        .footer--content__left_img{
          width: 1.5rem;
          height: auto;
          margin-bottom: .1rem;
        }
      }
      .footer--content__right{
        width: 50% !important;
      }
    }
  }
   }
    
  // 屏幕大小适配
  @media screen and (min-width: 751px) and (max-width: 1024px) {
    .footer--content__center{
      width: 50% !important;
        // .footer--content__center_nav{
        //   h3{
        //     // font-size: 17px !important;
        //     // line-height: 40px !important;
        //   }
        //   li{
        //     // font-size: 13px !important;
        //     // line-height: 28px !important;
        //   }
        // }
      }
  }
  @media screen and (min-width: 1025px) and (max-width: 1300px) {
    .footer--content__center{
      width: 43% !important;
    }
  }
 
</style>


// WEBPACK FOOTER //
// src/components/footer.vue